<template>
  <div>
    <section class="notifications">
      <div class="notifications__content">
        <header class="notifications__header">
          <img class=""
               src="static/images/notifications_store/notifications_header.png">
          <h1>{{ getTranslations.home_notifications_title }}</h1>
        </header>
        <div class="notifications__list">
          <span v-for="(notificationToday, index) in initNotificationData" :key="index"></span>
          <div v-for="(notificationBar, index) in notificationArraysBar"
               :key="index">
            <div class="notifications__list__seperator">
              {{ notificationBar.notificationDate | getFormatForBar }}
            </div>
            <ul v-for="(notification, index) in notificationArrays"
                :key="index"
                v-if="hasTheSameDate(notification.id, notificationBar.notificationDate)">
            <li :class="[ notification.data.readStatus ? 'read' : '', notification.data.notificationCategoryDTO.name === 'Bonus Points' ? 'bonus' : '' ]">
              <div class="notifications__list__icon">
                <img :src="notification.data.notificationCategoryDTO.imgUrl"
                     alt="">
              </div>
              <div class="notifications__list__text">
                <strong>{{ notificationTranslationMethod(notification.data.notificationCategoryDTO.name, notification.data.bonusPoints, notification.data.gamesEarned) }}</strong>
                <p>{{ notificationTranslationMethodText(notification.data.notificationCategoryDTO.name, notification.data.notificationCategoryDTO.value, notification.data.text) }}</p>
                <span>{{ notification.data.notificationDate | getFormat }}</span>
              </div>
              <div class="notifications__list__button">
                <a style="cursor: pointer"
                   class="btn2 btn2--std btn2--small btn2--green"
                   v-if="getCheckItButton(notification.data.notificationCategoryDTO.name)"
                   @click.prevent="checkIt(notification.data)">{{ getCheckItButton(notification.data.notificationCategoryDTO.name) }}
                </a>
              </div>
            </li>
          </ul>
          </div>
          <a style="cursor: pointer"
             v-show="hasMore"
             @click.prevent="displayMore"
             class="load-more">···
          </a>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }] */
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import Vue from 'vue';
import NewGameMixin from '@/common/mixins/home';
import RoundUpMixin from '@/common/mixins/roundUp';
import LevelUp from './modals/LevelUp';
import PrizeDetails from './modals/PrizeDetails';
import PostGame from './modals/PostGame';
import PostGamePrize from './modals/PostGamePrize';
import Ranking from './modals/Ranking';
import modals from '../../common/modals';


const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'notifications',
  components: {
    LevelUp,
    PrizeDetails,
    Ranking,
  },
  mixins: [RoundUpMixin, NewGameMixin],
  data() {
    return {
      prizeDetails: {
        winDTO: {
          name: null,
          imageUrl: null,
        },
      },
      gameType: null,
      currentModal: null,
      showedModal: false,
      showmore: false,
      extraArrays: [],
      userNotifications: [],
      displayNotifications: [],
      displayDifferentDaysNotifications: [],
      displayBlackBar: [],
      unreadNotifications: 0,
      moreNotifications: false,
      hiddenNotificationsNumber: 5,
    };
  },
  beforeRouteEnter(to, from, next) {
    // eslint-disable-next-line
    console.log('==> inside component\'s beforeRouteEnter:');
    if (process.env.NODE_ENV !== 'production') {
      const deepCloneForStrictError = JSON.parse(JSON.stringify(localStorage.getItem('locale')));
      moment.locale(deepCloneForStrictError);
    } else {
      moment.locale(localStorage.getItem('locale'));
    }
    next();
  },
  created() {
    this.getUserNotifications().then(() => {
      this.numberOfUnreadNotifications();
    });
  },
  mounted() {
    this.numberOfUnreadNotifications();
    if (this.unreadNotifications > 0) {
      this.changeNotificationReadStatus().then(() => {
        this.getUserNotifications().then(() => {
          // eslint-disable-next-line
          this.userNotifications = this.notifications;
          this.numberOfUnreadNotifications();
        });
      });
    }
  },
  methods: {
    ...mapActions('profile', [
      'changeNotificationReadStatus',
      'getUserNotifications',
      'getUserLoginDetails',
      'clearNotifications',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('game', [
      'setGameID',
      'updateGameType',
      'resetPrizeData',
      'resetGameState',
      'updatePrizePostGameData',
      'isGamePageFlow',
    ]),
    ...mapMutations('profile', [
      'setShowmodalForLevelUp',
      'setShowmodalForRanking',
      'setShowmodalForDefaultPrizeDetails',
      'setShowModalForGrandPrize',
      'setCheckedNotificationId',
      'setCheckedNotificationReadStatus',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
    ]),
    numberOfUnreadNotifications() {
      // comment next line for dev purpose
      this.userNotifications = this.notifications;
      this.unreadNotifications = 0;
      for (let i = 0; i < this.userNotifications.length; i += 1) {
        if (this.userNotifications[i].readStatus === false) {
          this.unreadNotifications = this.unreadNotifications + 1;
        }
      }
    },
    getCheckItButton(notification) {
      switch (notification) {
      case this.getNotificationsNames.bonusRegistration:
      case this.getNotificationsNames.bonusPointsRank:
      case this.getNotificationsNames.bonusPointsReferral:
      case this.getNotificationsNames.bonusPointsLevelUp:
      case this.getNotificationsNames.bundlePurchaseWarning:
      case this.getNotificationsNames.CoinsExpiration:
      case this.getNotificationsNames.fbShareVictory:
        return '';
      case this.getNotificationsNames.IncompleteGame:
      case this.getNotificationsNames.CompleteGame:
        return this.getTranslations.home_notifications_choose_prize;
      case this.getNotificationsNames.fbShareJackPot:
      case this.getNotificationsNames.JackPotCountDown:
        return this.getTranslations.home_notifications_see_jackpot;
      default:
        return this.getTranslations.home_notifications_check_it;
      }
    },
    notificationTranslationMethodText(name, value, text) {
      /* eslint-disable */
      // only for this case we want the value of NotificationDTO for the referral notification
      if (value === 'Referral') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_referral_registration_before_username')).toString()];
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_referral_registration_after_username')).toString()];
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'Ranking') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_ranking_before')).toString()]; // You earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_ranking_after')).toString()]; // Bonus Points for sharing your Rank on Facebook!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'LevelUp') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_level_up_before')).toString()]; // You earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_level_up_after')).toString()]; // Bonus Points for sharing your Level Up Success on Facebook!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'Registration') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_registration_before')).toString()]; // You connected successfully to Facebook and earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_registration_after')).toString()]; // Bonus Points!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'BundlePurchaseWarning') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bundle_purchase_before')).toString()];
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bundle_purchase_after')).toString()];
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'fbShareJackPot') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_share_jackpot_text_before')).toString()]; // You earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_share_jackpot_text_after')).toString()]; //  Bonus points for sharing your victory with your Facebook friends!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'CoinsExpiration') {
        return this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_coins_expiration_text')).toString()]; // You earned
      } else if (value === 'fbShareVictory') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_share_victory_before')).toString()]; // You earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_share_victory_after')).toString()]; //  Bonus points for sharing your victory with your Facebook friends!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'JackPotCountDown') {
        return this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_jackpot_text_before')).toString()];
      } else if (value === 'IncompleteGame' || value === 'CompleteGame') {
        return this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_incomplete_game_text')).toString()];
      }
      return this.getTranslations[(this.getTranslationsKeys.filter(key => key === text)).toString()];
    },
    notificationTranslationMethod(text, valueText, smartField) {
      console.log('The text is ' + text);
      if (text === this.getNotificationsNames.bonusRegistration) {
        text = 'home_modals_notifications_bonus_registration';
      }
      if (text === this.getNotificationsNames.bonusPointsReferral) {
        const text1 = this.getTranslations['home_notifications_friend_referral_title'];
        return '+' + smartField  + ' ' + text1; // +X games for you
      }
      if (text === this.getNotificationsNames.bonusPointsLevelUp) {
        text = 'home_modals_notifications_bonus_points';
      }
      if (text === this.getNotificationsNames.IncompleteGame || text === this.getNotificationsNames.CompleteGame) {
        text = 'home_notifications_incomplete_game_title';
      }
      if (text === this.getNotificationsNames.JackPotCountDown) {
        text = 'home_notifications_jackpot_title';
      }
      if (text === this.getNotificationsNames.CoinsExpiration) {
        text = 'home_notifications_coins_expiration_title1';
      }
      return this.getTranslations[(this.getTranslationsKeys.filter(key => key === text)).toString()];
      /* eslint-enable */
    },
    displayMore() {
      this.moreNotifications = true;
      this.extraArrays = [];
      this.displayBlackBar = [];
    },
    checkIt(notification) {
      this.storeModalForHomePage(null);
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        if (this.displayDifferentDaysNotifications[i].data.id === notification.id) break;
      }
      this.sendNotificationIdtoDB(notification);
    },
    checkIfNotificationIsOfType(notification, type) {
      return notification.notificationCategoryDTO.value === type;
    },
    sendNotificationIdtoDB(notificationIdtoDB) {
      this.setCheckedNotificationId({ value: notificationIdtoDB.id });
      this.setCheckedNotificationReadStatus({ value: notificationIdtoDB.readStatus });
      this.setNotificationRewardName({ value: notificationIdtoDB.text });
      this.setNotificationPrizeWon({ value: notificationIdtoDB.hasWon });
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.IncompleteGame) {
        this.setGameID(notificationIdtoDB.gameId);
        this.isGamePageFlow(false);
        this.updateGameType(notificationIdtoDB.gameType);
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.CompleteGame) {
        this.updateGameType(notificationIdtoDB.gameType);
        // eslint-disable-next-line
        const winDTO = {
          imageWonUrl: notificationIdtoDB.prizeImgUrl,
          name: notificationIdtoDB.prizeDesc,
        };
        this.updatePrizePostGameData({ winDTO });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.levelUp) {
        // eslint-disable-next-line
        const notificationLevelupData = {
          userLevel: notificationIdtoDB.userLevel,
          bonusPoints: notificationIdtoDB.bonusPoints,
          gamesToNextLevel: notificationIdtoDB.gamesEarned,
        };
        // temp
        this.setShowmodalForLevelUp({ notificationLevelupObject: notificationLevelupData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.topRanking) {
        const notificationRankingData = {
          userLevel: notificationIdtoDB.userLevel,
          bonusPoints: notificationIdtoDB.bonusPoints,
          gamesToNextLevel: notificationIdtoDB.gamesEarned,
        };
        // temp
        this.setShowmodalForRanking({ notificationRankingObject: notificationRankingData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.monthlyPrize ||
        notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.weeklyPrize || notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.dailyPrize) {
        if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.monthlyPrize) {
          const notificationPrizeDetailsData = this.getMonthlyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        } else if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.weeklyPrize) {
          const notificationPrizeDetailsData = this.getWeeklyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        } else if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.dailyPrize) {
          const notificationPrizeDetailsData = this.getDailyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        }
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.grandPrize) {
        const notificationPrizeDetailsData = this.getGrandPrize;
        // temp
        this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.JackPotCountDown) {
        this.$router.push('/home/jackpot');
      }
      this.showModalMethod(notificationIdtoDB.notificationCategoryDTO.name);
    },
    showModalMethod(notificationModalName) {
      if (notificationModalName === this.getNotificationsNames.monthlyPrize || notificationModalName === this.getNotificationsNames.grandPrize ||
        notificationModalName === this.getNotificationsNames.weeklyPrize || notificationModalName === this.getNotificationsNames.dailyPrize) {
        this.storeModalForHomePage(PrizeDetails);
        this.showModal();
      } else if (notificationModalName === this.getNotificationsNames.levelUp) {
        this.storeModalForHomePage(LevelUp);
        this.showModal();
      } else if (notificationModalName === this.getNotificationsNames.topRanking) {
        this.storeModalForHomePage(Ranking);
        this.showModal();
      } else if (notificationModalName === this.getNotificationsNames.IncompleteGame) {
        this.storeModalForHomePage(PostGame);
        modals.showHideModalForGameNotificationPage(this);
      } else if (notificationModalName === this.getNotificationsNames.CompleteGame) {
        this.storeModalForHomePage(PostGamePrize);
        this.showModal();
      }
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          this.getUserNotifications().then(() => {
            this.userNotifications = this.notifications;
            this.numberOfUnreadNotifications();
          });
          if (!this.showedModal) {
            this.showedModal = true;
            this.currentModal = null;
            this.storeModalForHomePage(null);
            this.resetPrizeData();
            this.resetGameState();
          } else {
            this.storeModalForHomePage(null);
            this.currentModal = null;
            this.resetPrizeData();
            this.resetGameState();
          }
        });
      });
      /* eslint-enable */
    },
    clearData() {
      this.clearNotifications().then(() => {
        this.displayNotifications = [];
        this.displayDifferentDaysNotifications = [];
        this.displayBlackBar = [];
        this.extraArrays = [];
        this.showmore = false;
        this.userNotifications = [];
      });
    },
    hasTheSameDate(notificationDate1, notificationDate2) {
      return (moment(notificationDate1).format('L') === moment(notificationDate2).format('L'));
    },
  },
  computed: {
    ...mapState('common', [
      'modalForHomePage',
    ]),
    ...mapState('profile', [
      'notifications',
      'jwtInVuex',
    ]),
    ...mapGetters('common', [
      'getNotificationsNames',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationsKeys',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getGrandPrize',
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
    ]),
    hasMore() {
      return this.showmore;
    },
    initNotificationData() {
      /* eslint-disable */
      this.displayNotifications = [];
      this.displayDifferentDaysNotifications = [];
      this.displayBlackBar = [];
      for (let i = 0; i < this.userNotifications.length; i += 1) {
        this.displayNotifications.push(this.userNotifications[i]);
      }
      this.displayNotifications = this.displayNotifications.filter(e => e);// delete null values
      for (let i = 0; i < this.displayNotifications.length; i += 1) {
        if (i === 0) {
          const first = {
            id: this.displayNotifications[i].notificationDate,
            data: this.displayNotifications[i],
          };
          this.displayDifferentDaysNotifications.push(first);
        } else {
          let notific = {
            id: '',
            data: '',
          };
          for (let k = 0; k < this.displayDifferentDaysNotifications.length; k += 1) {
            if (moment(this.displayNotifications[i].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[k].data.notificationDate).format('L')) {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
              break;
            } else {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
            }
          }
          this.displayDifferentDaysNotifications.push(notific);
        }
      }
      return [];
      /* eslint-enable */
    },
    notificationArraysBar() { // notifications from the same date have the same notificationDate
      /* eslint-disable */
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        const notific = {
          id: '',
          notificationDate: '',
        };
        if (i === 0) {
          const first = {
            id: this.displayDifferentDaysNotifications.length - 1,
            notificationDate: this.displayDifferentDaysNotifications[i].data.notificationDate,
          };
          this.displayBlackBar.push(first);
        } else {
          let isAlreadyInArray = false;
          for (let k = 0; k < this.displayBlackBar.length; k += 1) {
            isAlreadyInArray = false;
            if (moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L')) {
              break;
            } else if (!(moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L'))) {
              isAlreadyInArray = true;
              notific.id = k;
              notific.notificationDate = this.displayDifferentDaysNotifications[i].data.notificationDate;
            }
          }
          if (isAlreadyInArray) {
            this.displayBlackBar.push(notific);
          }
        }
      }
      this.displayBlackBar.sort((a, b) => b.notificationDate - a.notificationDate);
      this.showmore = false;
      if ((this.displayBlackBar.length > this.hiddenNotificationsNumber) && this.moreNotifications === false) {
        this.showmore = true;
        for (let k = this.hiddenNotificationsNumber; k < this.displayBlackBar.length; k += 1) {
          this.extraArrays.push(this.displayBlackBar[k]);
          delete this.displayBlackBar[k];
        }
      }
      this.displayBlackBar = this.displayBlackBar.filter(e => e); // delete null values
      return this.displayBlackBar;
      /* eslint-enable */
    },
    notificationArrays() {
      return this.displayDifferentDaysNotifications;
    },
  },
  filters: {
    getFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getFormatForBar(dateInBar) {
      return moment(dateInBar).format('LL');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Notifications.vue